<template>
  <div class="navbar" :class="{ nobackground: !nobackground }">
    <div class="breadcrumb">
      <!-- style=`background-image:url(${house})` -->
      <div class="houseStyle" :style="houseStyle"></div>
      <span
        class="bread-item"
        v-for="item in $route.matched"
        :key="item.path"
        @click="breadcrumbClick(item)"
      >
        {{ item.meta ? item.meta.title || item.name : item.name }}
      </span>
      <el-tag
        v-for="(tag, index) in tagsList"
        :key="index"
        closable
        size="mini"
        :type="tag.type"
        @close="tagClose(index)"
        @click="tagClick(tag)"
      >
        {{ tag.meta.title }}
      </el-tag>
    </div>
    <div style="min-width: 240px;">
      <el-row>
<!--        <el-col :span="9">-->
<!--          <el-select v-model="fcCode" size="mini" style="width: 75px;" @change="changeLodinFc()">-->
<!--            <el-option value="DLM" key="DLM"></el-option>-->
<!--            <el-option value="DLN" key="DLN"></el-option>-->
<!--          </el-select>-->
<!--        </el-col>-->
        <el-col :span="14">
        <span class="bread-item">
          {{user}}
        </span>
        </el-col>
        <el-col :span="3">
          <el-image
           @click="userClick"
            style="width: 20px;"
            :src="require('@/assets/img/蒙版组12@3x.png')"
          ></el-image>
        </el-col>
        <el-col :span="3">
          <el-button
            class="EL-Button"
            circle
            size="small"
            style="color: #0080ff"
            icon="el-icon-message-solid"
          ></el-button>
        </el-col>
        <el-col :span="3">
          <el-button
            class="EL-Button"
            circle
            size="small"
            style="color: #0080ff"
            icon="el-icon-switch-button"
            @click="logout"
          ></el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import house from "@/assets/house.png";
export default {
  name: "Navbar",
  props: {
    nobackground: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  inject:['reload'],
  data() {
    return {
      house,
      isCollapse: false,
      pageName: "",
      breadcrumb: [],
      menu: [],
      fcCode: localStorage.getItem("fcCode"),
      userAccount: "",
      userId: "",
      user:localStorage.getItem("user")
    };
  },
  methods: {
    ...mapMutations(["setTags"]),
    tagClose(index) {
      this.setTags(index);
    },
    tagClick(tag) {
      this.$router.push(tag.path);
    },
    userClick(){
      this.$router.push("/center");
    },
    breadcrumbClick(route) {
      this.$router.push(route);
    },
    logout() {
      // this.$store.commit('clearTags')
      localStorage.clear();
      this.jump("/login");
    },
    changeLodinFc(){
      localStorage.removeItem("fcCode")
      localStorage.setItem("fcCode", this.fcCode || "");
      this.reload();
    },
  },
  computed: {
    ...mapState(["tagsList"]),
    houseStyle() {
      return {
        backgroundImage: `url(${house})`,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../style/variables.scss";

.navbar {
  color: rgb(0, 0, 0, 0.8);
  display: flex;
  padding: 0 10px;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  font-size: 0.9rem;
  // box-shadow: 0px 4px 8px 0px rgba(206, 206, 206, 0.43);
  // background: linear-gradient(left, #317bed, #234cd8);
  // background-color: #317bed;
  padding: 3px 0;
  margin: 0 0 5px 5px;
  padding-right: 20px;
  background-color: white;

  &.nobackground {
    background-color: transparent;
    box-shadow: none;
  }
}

.breadcrumb {
  width: auto;
  // display: inline-block;
//   display: flex;
//   align-content: center;

  .bread-item {
    cursor: pointer;

    &:hover {
      color: $maincolor;
    }

    &::after {
      content: ">";
      font-weight: bold;
      margin: 0 8px;
    }
  }

  .bread-item:last-child {
    // color: $maincolor;
    // color: white;
    color: rgb(0, 0, 0, 0.8);

    &::after {
      display: none;
    }
  }
}

.logo-img {
  cursor: pointer;
  margin: 0 20px;
  height: 45px;
  width: auto;
}

.el-tag--mini{
  cursor: pointer;
}
</style>